import { RootState } from '../../RootState';
import { SearchSettings } from '@spa/lib/store/settings/SearchSettings';

const selectSearchSettings = (state: RootState): SearchSettings => {
  const settings = state.settings.settings;

  if (settings === null) {
    throw new Error('Search settings should be initialized.');
  }

  return settings.searchSettings;
};

export default selectSearchSettings;
